import { useMemo } from "react";
import artikelApi from "@/api/artikler";
import { ArtikelPageOptions } from "@/interfaces/paging";
import styles from "./Artikler.module.scss";
import TwoPaneView from "@/components/common/layout/TwoPaneView";
import Sidebar from "./Sidebar/Sidebar";
import ArtikelVisning from "./Main/Artikel";
import ArtikelList from "./Main/ArtikelList";
import Pointer from "@/components/common/icons/Pointer";
import PageContainer from "@/components/common/layout/PageContainer";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
//import { Artikel } from "@/interfaces/Artikler";

export interface IArtiklerState {
  state: "IDLE" | "LOADING" | "ERROR";
  visning: "LISTE" | "ARTIKEL" | "INGEN";
  data: Artikel[];
  temaer: { antal: number; tema: ArtikelTema }[];
  currentData: ArtikelListeMedTema | Artikel | undefined;
}
const pageoptions: ArtikelPageOptions = {
  page: 1,
  pageSize: 99999,
  trimindhold: true,
  offentlig: true,
};

export default function Artikler() {
  const [searchParams] = useSearchParams();
  const temaid = searchParams.get("temaid");
  const artikelid = searchParams.get("artikelid");

  const { data, isFetching } = useQuery<Artikel[], Error>({
    queryKey: ["artikler", pageoptions],
    queryFn: () => artikelApi.getAll(pageoptions),
  });

  const temaer = useMemo(() => {
    const temaer: { antal: number; tema: ArtikelTema }[] = [];
    if (!data) return temaer;
    for (const a of data) {
      const tema = temaer.find((tema) => tema.tema.id === a.temaId);
      if (tema) {
        tema.antal = tema.antal + 1;
      } else {
        temaer.push({ antal: 1, tema: { id: a.temaId, navn: a.temaNavn } });
      }
    }

    return temaer;
  }, [data]);

  const renderMain = () => {
    if ((!artikelid && !temaid) || !data)
      return (
        <PageContainer classNames={styles.placeholder_content}>
          <div className={styles.placeholder}>
            <span className={styles.arrow}>
              <Pointer width={45} />
            </span>
            <p>Vælg et tema i panelet til venstre</p>
          </div>
        </PageContainer>
      );
    if (artikelid) return <ArtikelVisning artikelId={artikelid} />;
    const tema = temaid && temaer.find((t) => t.tema.id === temaid)?.tema.navn;
    return (
      <ArtikelList
        artikelListeMedTema={{
          artikler:
            temaid && temaid !== "-1"
              ? data.filter((a) => a.temaId === temaid)
              : data,
          tema: tema || "Hjælp til fejllister",
        }}
      />
    );
  };
  return (
    <TwoPaneView
      sidebar={
        <Sidebar
          totaltAntalArtikler={data?.length ?? 0}
          currentTemaId={temaid || "-1"}
          temaer={temaer}
          isFetching={isFetching}
        />
      }
      main={
        <div className={styles.container} id="artikler-content">
          {renderMain()}
        </div>
      }
    />
  );
}
